export default __webpack_public_path__ + "static/media/image.4544f8f7.jpg";